import { Fetch } from "../lib/fetch";
import { logoutAction } from "./logout";

export const deleteUserAction = async () =>
    Fetch(`remove-user`, { method: "POST" }, "auth")
        .catch(e => {
            console.log("error at delete person from database", e);
        })
        .then(logoutAction);
